function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'fast-deep-equal';
import PhoneInput from 'react-phone-number-input';
import { getIsInputValueReset } from "../../../utils/get-is-input-value-reset";
import { getControlledInputValue } from "../../../utils/get-controlled-input-value";
import { InputController } from "../InputController";
import { INITIAL_VALUE, COUNTRY_OPTIONS, DEFAULT_COUNTRY } from "./constants";
import { FlagComponent } from "./utils/FlagComponent";
import { CountrySelectComponent } from "./utils/CountrySelectComponent";
import { getLabels } from "./utils/getLabels";
export var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      labels: getLabels(_this.props.countryNames),
      value: INITIAL_VALUE
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (name, value) {
      return _this.setState({
        value: value
      });
    });

    return _this;
  }

  _createClass(Component, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps, previousState) {
      if (getIsInputValueReset(previousProps.value, this.props.value)) {
        this.setState({
          value: INITIAL_VALUE
        });
        return;
      }

      var value = this.state.value;
      var _this$props = this.props,
          name = _this$props.name,
          onChange = _this$props.onChange;
      !isEqual(previousState.value, value) && onChange(name, value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          autoComplete = _this$props2.autoComplete,
          error = _this$props2.error,
          initialCountryValue = _this$props2.initialCountryValue,
          isValid = _this$props2.isValid,
          label = _this$props2.label,
          name = _this$props2.name,
          onBlur = _this$props2.onBlur;
      var value = getControlledInputValue(this.props.value, INITIAL_VALUE, this.state.value);
      return React.createElement(InputController, {
        error: error,
        isValid: isValid,
        label: label,
        name: name,
        onChange: this.handleChange,
        value: value
      }, React.createElement(PhoneInput, {
        autoComplete: autoComplete,
        country: initialCountryValue,
        countryOptions: COUNTRY_OPTIONS,
        countrySelectComponent: CountrySelectComponent,
        flagComponent: FlagComponent,
        labels: this.state.labels,
        onBlur: onBlur
      }));
    }
  }]);

  return Component;
}(PureComponent);
Component.displayName = 'PhoneInput';
Component.defaultProps = {
  autoComplete: 'off',
  error: false,
  countryNames: {},
  initialCountryValue: DEFAULT_COUNTRY,
  isValid: false,
  label: '',
  name: '',
  onBlur: Function.prototype,
  onChange: Function.prototype,
  value: undefined
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  autoComplete: PropTypes.string,
  countryNames: PropTypes.objectOf(PropTypes.string),
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  initialCountryValue: PropTypes.string,
  isValid: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string
} : {};